import { useCallback } from 'react';
import PropTypes from 'prop-types';
import Stack from '@mui/material/Stack';
import { useDispatch, useSelector } from 'react-redux';

import { saveSetting } from 'features/views/settings/actions';
import { getFilterAccordingId } from 'features/views/settings/selectors';
import { getCodelistPropById } from 'utils';

import InformationSettingSwitch from './InformationSettingSwitch';
import ListItemSubFilters from './ListItemSubFilters';

export const ListItem = ({ filterId, taskTypesCodelist, taskSubtypesCodelist }) => {
	const dispatch = useDispatch();

	const filter = useSelector((state) => getFilterAccordingId(state, filterId));
	const taskTypeId = filter.taskTypeId;
	const subTypes = filter.subTypes;

	const handleCheckFilter = useCallback(
		(filter) => () => {
			dispatch(saveSetting(filter));
		},
		[dispatch],
	);

	return (
		<Stack>
			<InformationSettingSwitch
				value={filter?.enabled}
				description={getCodelistPropById(taskTypeId, taskTypesCodelist, 'description')}
				onChange={handleCheckFilter(filter)}
				tooltip={filter?.tooltip}
			/>

			{subTypes && <ListItemSubFilters subFilters={subTypes} taskSubtypesCodelist={taskSubtypesCodelist} />}
		</Stack>
	);
};

ListItem.propTypes = {
	filterId: PropTypes.number,
	taskSubtypesCodelist: PropTypes.arrayOf(PropTypes.object),
	taskTypesCodelist: PropTypes.arrayOf(PropTypes.object),
};

export default ListItem;
